if (window._ddLoginDrawerInit) throw new Error('duplicate');
window._ddLoginDrawerInit = true;

class LoginDrawer extends HTMLElement {
  constructor() {
    super();
    this._isSubmitting = false;
    this._activeElement = null;

    this.overlay = this.querySelector('#LoginDrawer-Overlay');
    this.inner = this.querySelector('#LoginDrawer');
    this.closeBtn = this.querySelector('.login-drawer__close');
    this.form = this.querySelector('#LoginDrawerForm');
    this.errorEl = this.querySelector('#LoginDrawer-Error');
    this.errorMsg = this.querySelector('#LoginDrawer-ErrorMsg');
    this.submitBtn = this.querySelector('#LoginDrawer-Submit');
    this.submitText = this.querySelector('.login-drawer__submit-text');
    this.spinner = this.querySelector('.login-drawer__spinner');
    this.emailInput = this.querySelector('#LoginDrawer-Email');
    this.passwordInput = this.querySelector('#LoginDrawer-Password');
    this.eyeBtn = this.querySelector('[data-login-eye]');

    this._bindEvents();
    this._bindTriggers();
  }

  _bindEvents() {
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    this.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.close(); });
    this.addEventListener('click', (e) => {
      if (this.inner && !this.inner.contains(e.target)) this.close();
    });

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this._handleSubmit();
      });
    }

    if (this.eyeBtn && this.passwordInput) {
      this.eyeBtn.addEventListener('click', () => {
        var isPassword = this.passwordInput.type === 'password';
        this.passwordInput.type = isPassword ? 'text' : 'password';
        this.eyeBtn.classList.toggle('is-visible', isPassword);
        this.eyeBtn.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
      });
    }
  }

  _bindTriggers() {
    document.querySelectorAll('[data-login-drawer-open]').forEach((link) => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
    });

    this._onOpenTriggerClick = (e) => {
      var link = e.target && e.target.closest ? e.target.closest('[data-login-drawer-open]') : null;
      if (!link) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      this.open(link);
    };
    document.addEventListener('click', this._onOpenTriggerClick, true);
  }

  open(triggeredBy) {
    if (triggeredBy) this._activeElement = triggeredBy;
    this._closeOtherDrawers();
    this._hideError();
    if (this.form) this.form.reset();

    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, 10);

    document.body.classList.add('overflow-hidden', 'login-drawer-open');

    this.addEventListener('transitionend', () => {
      if (this.inner) this.inner.focus({ preventScroll: true });
      if (typeof trapFocus === 'function') trapFocus(this.inner, this.inner);
    }, { once: true });
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden', 'login-drawer-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this._activeElement);
    this._activeElement = null;
  }

  _closeOtherDrawers() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active')) cartDrawer.close();
    var menuDetails = document.querySelectorAll('header-drawer details[open]');
    menuDetails.forEach(function(d) { d.removeAttribute('open'); });
    document.body.className = document.body.className.replace(/overflow-hidden[^ ]*/g, '').trim();
  }

  async _handleSubmit() {
    if (this._isSubmitting) return;
    if (!this.emailInput.value || !this.passwordInput.value) return;

    this._isSubmitting = true;
    this._hideError();
    this._setLoading(true);

    try {
      var res = await fetch(this.form.action, {
        method: 'POST',
        body: new URLSearchParams(new FormData(this.form)),
        credentials: 'same-origin',
        redirect: 'follow'
      });

      var html = await res.text();

      var isLoginPage = res.url.indexOf('/account/login') !== -1
        || html.indexOf('Invalid login') !== -1
        || html.indexOf('Incorrect email') !== -1
        || html.indexOf('incorrect') !== -1;

      if (isLoginPage) {
        var errorText = this._parseError(html);
        this._showError(errorText || 'Invalid email or password. Please try again.');
        this._finishSubmit();
        return;
      }

      this._debug('login-success', { url: res.url });
      this._freeze();

    } catch (err) {
      console.error('[LoginDrawer]', err);
      this._showError('Something went wrong. Please try again.');
      this._finishSubmit();
    }
  }

  _freeze() {
    try {
      sessionStorage.setItem('dd-login-reveal', '1');
      sessionStorage.setItem('dd-auth-transition', 'login');
    } catch (e) {}

    this.close();

    document.documentElement.style.pointerEvents = 'none';
    document.documentElement.style.userSelect = 'none';

    var currentUrl = window.location.pathname + window.location.search;
    this._debug('freeze-reload', { url: currentUrl || '/' });
    window.location.href = currentUrl || '/';
  }

  async _hydrateAfterLogin() {
    var root = document.documentElement;
    try {
      var currentUrl = window.location.pathname + window.location.search;
      var sectionJoin = currentUrl.indexOf('?') === -1 ? '?' : '&';
      var currentHeaderSection = document.querySelector('.shopify-section.section-header');
      var sectionId = currentHeaderSection && currentHeaderSection.id
        ? currentHeaderSection.id.replace(/^shopify-section-/, '')
        : 'header';
      this._debug('hydrate-start', { sectionId: sectionId });
      var headerRes = await fetch(currentUrl + sectionJoin + 'sections=' + encodeURIComponent(sectionId), {
        method: 'GET',
        credentials: 'same-origin'
      });
      if (!headerRes.ok) return false;

      var headerJson = await headerRes.json();
      var headerHtml = headerJson && (headerJson[sectionId] || headerJson.header);
      if (!headerHtml) return false;

      this._lockHydrationUI(root);
      this._ensureHydrationStyle();

      var parser = new DOMParser();
      var headerDoc = parser.parseFromString(headerHtml, 'text/html');

      var accountHref = '/account';
      var nextDesktopAccount = headerDoc.querySelector('.glass-nav-utility-link--login');
      var currentDesktopAccount = document.querySelector('.glass-nav-utility-link--login');
      if (nextDesktopAccount && currentDesktopAccount) {
        accountHref = nextDesktopAccount.getAttribute('href') || accountHref;
        currentDesktopAccount.outerHTML = nextDesktopAccount.outerHTML;
      } else {
        return false;
      }

      var nextDrawerLoginBtn = headerDoc.querySelector('.glass-drawer-login-btn');
      var currentDrawerLoginBtn = document.querySelector('.glass-drawer-login-btn');
      if (currentDrawerLoginBtn) {
        if (nextDrawerLoginBtn) {
          currentDrawerLoginBtn.outerHTML = nextDrawerLoginBtn.outerHTML;
        } else {
          currentDrawerLoginBtn.remove();
        }
      }

      var nextApplyLink = headerDoc.querySelector('.glass-drawer-apply-link');
      var currentApplyLink = document.querySelector('.glass-drawer-apply-link');
      if (currentApplyLink) {
        if (nextApplyLink) {
          currentApplyLink.outerHTML = nextApplyLink.outerHTML;
        } else {
          currentApplyLink.remove();
        }
      }

      document.querySelectorAll('[data-login-drawer-open]').forEach(function (node) {
        node.removeAttribute('data-login-drawer-open');
        if (node.tagName === 'A') node.setAttribute('href', accountHref);
      });

      var cartDrawerRes = await fetch('/?section_id=cart-drawer', {
        method: 'GET',
        credentials: 'same-origin'
      });
      if (cartDrawerRes.ok) {
        var cartDrawerHtml = await cartDrawerRes.text();
        var cartDrawerDoc = parser.parseFromString(cartDrawerHtml, 'text/html');
        var nextCartDrawer = cartDrawerDoc.querySelector('cart-drawer');
        var currentCartDrawer = document.querySelector('cart-drawer');
        if (nextCartDrawer && currentCartDrawer) {
          currentCartDrawer.replaceWith(nextCartDrawer);
        }
      }

      root.setAttribute('data-glass-customer', 'true');
      await this._refreshProductSectionIfPresent();
      document.body.classList.remove('overflow-hidden', 'login-drawer-open');

      if (this.isConnected) this.remove();
      document.dispatchEvent(new CustomEvent('dd:login:hydrated'));
      var self = this;
      requestAnimationFrame(function () {
        self._unlockHydrationUI(root);
      });
      this._debug('hydrate-success');
      return true;
    } catch (err) {
      console.error('[LoginDrawer] hydrate failed', err);
      this._unlockHydrationUI(root);
      this._debug('hydrate-failed', { message: err && err.message ? err.message : 'unknown' });
      return false;
    }
  }

  async _refreshProductSectionIfPresent() {
    var productInfo = document.querySelector('product-info[data-section]');
    if (!productInfo) return true;

    var sectionId = productInfo.getAttribute('data-section');
    if (!sectionId) return true;

    var currentSection = document.getElementById('shopify-section-' + sectionId);
    if (!currentSection) return true;

    var currentUrl = window.location.pathname + window.location.search;
    var joiner = currentUrl.indexOf('?') === -1 ? '?' : '&';
    var sectionRes = await fetch(currentUrl + joiner + 'section_id=' + encodeURIComponent(sectionId), {
      method: 'GET',
      credentials: 'same-origin'
    });
    if (!sectionRes.ok) return false;

    var sectionHtml = await sectionRes.text();
    var sectionDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var nextSection = sectionDoc.getElementById('shopify-section-' + sectionId);
    if (!nextSection) return false;

    currentSection.innerHTML = nextSection.innerHTML;
    return true;
  }

  _ensureHydrationStyle() {
    if (document.getElementById('dd-auth-hydration-style')) return;
    var style = document.createElement('style');
    style.id = 'dd-auth-hydration-style';
    style.textContent =
      'html.dd-auth-hydrating, html.dd-auth-hydrating body { cursor: progress; }' +
      'html.dd-auth-hydrating *, html.dd-auth-hydrating *::before, html.dd-auth-hydrating *::after {' +
      'transition: none !important; animation: none !important;' +
      '}';
    document.head.appendChild(style);
  }

  _lockHydrationUI(root) {
    root.classList.add('dd-auth-hydrating');
    root.style.pointerEvents = 'none';
    root.style.userSelect = 'none';
  }

  _unlockHydrationUI(root) {
    root.classList.remove('dd-auth-hydrating');
    root.style.removeProperty('pointer-events');
    root.style.removeProperty('user-select');
  }

  _finishSubmit() {
    this._isSubmitting = false;
    this._setLoading(false);
  }

  _debug(eventName, payload) {
    if (!window.__ddAuthDebug) return;
    if (payload) {
      console.log('[LoginDrawer]', eventName, payload);
      return;
    }
    console.log('[LoginDrawer]', eventName);
  }

  _parseError(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var errorsEl = doc.querySelector('.errors, .form__message--error, [data-error], .form-message--error');
      if (errorsEl) return errorsEl.textContent.trim().replace(/\s+/g, ' ');
    } catch (e) {}
    return null;
  }

  _showError(msg) {
    if (this.errorEl && this.errorMsg) {
      this.errorMsg.textContent = msg;
      this.errorEl.hidden = false;
    }
  }

  _hideError() {
    if (this.errorEl) this.errorEl.hidden = true;
  }

  _setLoading(loading) {
    if (this.submitBtn) this.submitBtn.disabled = loading;
    if (this.submitText) this.submitText.hidden = loading;
    if (this.spinner) this.spinner.hidden = !loading;
    if (this.emailInput) this.emailInput.readOnly = loading;
    if (this.passwordInput) this.passwordInput.readOnly = loading;
  }

  disconnectedCallback() {
    if (this._onOpenTriggerClick) {
      document.removeEventListener('click', this._onOpenTriggerClick, true);
      this._onOpenTriggerClick = null;
    }
  }
}

customElements.define('login-drawer', LoginDrawer);
